module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "vbl-radio",
    class: {
      'is-disabled': _vm.disabled
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataValue),
      expression: "dataValue"
    }],
    attrs: {
      "type": "radio",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.nativeValue,
      "checked": _vm._q(_vm.dataValue, _vm.nativeValue)
    },
    on: {
      "change": function($event) {
        _vm.dataValue = _vm.nativeValue
      }
    }
  }), _c('span', {
    staticClass: "check"
  }), _c('span', {
    staticClass: "control-label"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-83e3898a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vblRadio/src/vblRadio.vue
// module id = 285
// module chunks = 0